module.exports = __webpack_public_path__ + "static/media/4000L.7a57384.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/4000L.mp3
// module id = Foea
// module chunks = 1